import { HttpErrorResponse, HttpResponse } from "@angular/common/http";
import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from "@angular/material/dialog";
import { Subject } from "rxjs";
import { finalize, takeUntil } from "rxjs/operators";
import { ErrorType } from "src/app/enums/error-type.enum";
import endpoints from "src/app/helpers/endpoints";
import { ApiService } from "src/app/services/api.service";
import { CommonService } from "src/app/services/common.service";
import * as moment from "moment";
import { FileClaimDetailComponent } from "src/app/pages/file-claim/file-claim-listing/file-claim-detail/file-claim-detail.component";

@Component({
  selector: "fury-claim-user-rep-log-modal",
  templateUrl: "./claim-user-rep-log-modal.component.html",
  styleUrls: ["./claim-user-rep-log-modal.component.scss"],
})
export class ClaimUserRepLogModalComponent implements OnInit, OnDestroy {
  columns = ["claimNumber", "updatedAt", "updatedContent"];
  ngUnsubscribe = new Subject<void>();
  dataSource = [];
  public objectKeys = Object.keys;
  public array = Array;
  isLoading = false;
  today = new Date();
  startDate: any;
  endDate: any;
  dateRangeForm = new FormGroup({
    start: new FormControl<Date | null>(null),
    end: new FormControl<Date | null>(null),
  });

  constructor(
    public dialogRef: MatDialogRef<ClaimUserRepLogModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private apiService: ApiService,
    public commonService: CommonService,
    private dialog: MatDialog
  ) {}

  ngOnInit() {
    if (this.data) {
      this.getClaimUserRepLog();
    }
  }
  close() {
    this.dialogRef.close();
  }
  getClaimUserRepLog() {
    this.isLoading = true;
    this.apiService
      .get(
        endpoints.user.getClaimUserRepLog(this.data?.userId) +
          `${
            this.startDate && this.endDate
              ? `?startDate=${this.startDate}&endDate=${this.endDate}`
              : ""
          }`
      )
      .pipe(
        finalize(() => (this.isLoading = false)),
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe({
        next: (res: HttpResponse<any>) => {
          this.dataSource = res.body?.claimHistories;
        },
        error: (err: HttpErrorResponse) => {
          this.apiService.alert(err.message, ErrorType.Error);
        },
      });
  }

  dateRangeChange(
    dateRangeStart: HTMLInputElement,
    dateRangeEnd: HTMLInputElement
  ) {
    this.startDate = moment(this.dateRangeForm.value.start).format(
      "YYYY-MM-DD HH:mm:ss"
    );
    this.endDate = moment(this.dateRangeForm.value.end).format(
      "YYYY-MM-DD HH:mm:ss"
    );
    this.getClaimUserRepLog();
  }
  clearDateRange() {
    this.dateRangeForm.patchValue({
      start: null,
      end: null,
    });
    this.startDate = null;
    this.endDate = null;
    this.getClaimUserRepLog();
  }
  handleViewDetails(row: any) {
    const obj = {
      width: "600px",
      data: row,
      panelClass: "custom-modalbox",
    };
    this.dialog.open(FileClaimDetailComponent, obj);
  }
  formatSubRoles(subRole: string): string {
    if (subRole) return subRole.replace(/,/g, ", ");
    return "";
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
